import React from 'react'
import SuperUserAccountPageUI from '../../../templates/SuperUserAccountPageUI.js'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import ClientDataNavUI from '../../../components/superUser/clientData/ClientDataNavUI'
import MCABalanceSheetUI from '../../../components/superUser/clientData/MCABalanceSheetUI'
import MCAProfitAndLossUI from '../../../components/superUser/clientData/MCAProfitAndLossUI'
import MCAChargeValueCalculationUI from '../../../components/superUser/clientData/MCAChargeValueCalculationUI'
import MCARatioAnalysisUI from '../../../components/superUser/clientData/MCARatioAnalysisUI'
import MCABalanceSheetChargesUI from '../../../components/superUser/clientData/MCABalanceSheetChargesUI'
import MCAShareHoldingPatternUI from '../../../components/superUser/clientData/MCAShareHoldingPatternUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import './MCAReportPage.css'

const MCAReportPageUI = ({ context, account,
  mcaReport, balanceSheetList, profitAndLossList, ratioAnalysisList, shareholdingPatternList, chargeValueCalculation,
  onRefreshClick, toggleEditable, editable,
  mcaParameterUpdateBSMode, onMcaParameterUpdateBSClick, onMcaParameterUpdateBSCancel,
  mcaParameterUpdatePLMode, onMcaParameterUpdatePLClick, onMcaParameterUpdatePLCancel,
  selectedParameterName, yearList
}) =>
  <SuperUserAccountPageUI context={context} className='pg_su_mca' backLink='/su/accounts'
    headerText={account && account.accountName} centered={!mcaReport}
    account={account} page='clientData' dimension='w768'
  >
    {
      !mcaReport &&
      <SpinnerComponentUI />
    }
    {
      mcaReport &&
      <div>
        <LRTableActionsUI location='top'
          left={
            <div className='g_flex_h'>
              <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
              <span className='g_m_left_100 g_large'><b>Client Data - MCA</b></span>
            </div>
          }
          right={<span />}
        />

        <ClientDataNavUI account={account} page='mca' />

        <div className='g_flex_h g_flex_left g_flex_wrap nav'>
          <a className='w_tab' href='#mcaBalanceSheet'>Balance Sheet</a>
          <a className='w_tab' href='#mcaSubCharges'>Subservient Charges</a>
          <a className='w_tab' href='#mcaChargeValue'>Charge Value Calculation</a>
          <a className='w_tab' href='#mcaPnL'>Profit and Loss</a>
          <a className='w_tab' href='#mcaRatioAnalysis'>Ratio Analysis</a>
          <a className='w_tab' href='#mcaShareHolding'>Shareholding Pattern</a>
        </div>

        <MCAReportUI
          context={context}
          mcaReport={mcaReport}
          onRefreshClick={onRefreshClick}
        />

        <MCABalanceSheetUI
          context={context} onRefreshClick={onRefreshClick}
          account={account} bsList={balanceSheetList} yearList={yearList}
          mcaParameterUpdateMode={mcaParameterUpdateBSMode}
          onMcaParameterUpdateClick={onMcaParameterUpdateBSClick}
          onMcaParameterUpdateCancel={onMcaParameterUpdateBSCancel}
          selectedParameterName={selectedParameterName}
        />
        <MCABalanceSheetChargesUI context={context} account={account} bsList={balanceSheetList} />
        <MCAChargeValueCalculationUI chargeValueCalculation={chargeValueCalculation} toggleEditable={toggleEditable} editable={editable} />
        <MCAProfitAndLossUI
          context={context} onRefreshClick={onRefreshClick}
          account={account} pnlList={profitAndLossList} yearList={yearList}
          mcaParameterUpdateMode={mcaParameterUpdatePLMode}
          onMcaParameterUpdateClick={onMcaParameterUpdatePLClick}
          onMcaParameterUpdateCancel={onMcaParameterUpdatePLCancel}
          selectedParameterName={selectedParameterName}
        />
        <MCARatioAnalysisUI raList={ratioAnalysisList} />
        <MCAShareHoldingPatternUI shpList={shareholdingPatternList} />
      </div>
    }
  </SuperUserAccountPageUI>

const MCAReportUI = ({ context, mcaReport }) =>
  <div id='mcaReport' className='g_m_top_100'>
    <table className='g_table mca_table'>
      <thead><tr className='g_text_right'>
        {/* {
        Object.entries(mcaReport).map(([name, value]) =>
          <RowUI key={name} context={context} name={name} value={value} />
        )
      } */}
      </tr></thead>
      <tbody>
        {
          Object.entries(mcaReport).map(([name, value]) =>
            <RowUI key={name} name={name} value={value} />
          )
        }
        {/* {
      shpList.map((shp, i) =>
        <RowUI shp={shp}/>
      )
      } */}
      </tbody>
    </table>
  </div>

const RowUI = ({ name, value }) =>
  <tr>
    <td>
      <Desc name={name} />
    </td>
    <td className='g_text_right'>
      {value}
    </td>
  </tr>

const Desc = ({ name }) =>
  <span>
    {(() => {
      switch (name) {
        case 'adverseRemarksByAuditorInConsolidated':
          return 'Adverse Remarks by Auditor in Consolidated'
        case 'adverseRemarksByAuditorInStandalone':
          return 'Adverse Remarks by Auditor in Standalone'
        case 'authorizedEquityShareCapitalInr':
          return 'Authorized Equity Share Capital INR'
        case 'authorizedPreferenceShareCapitalInr':
          return 'Authorized Preference Share Capital INR'
        case 'cin':
          return 'CIN'
        case 'companyName':
          return 'Company Name'
        case 'companyStatus':
          return 'Company Status'
        case 'companySubcategory':
          return 'Company Subcategory'
        case 'dateOfBalanceSheet':
          return 'Date of Balance Sheet'
        case 'dateOfIncorporation':
          return 'Date of Incorporation'
        case 'dateOfLastAgm':
          return 'Date of Last Agm'
        case 'emailId':
          return 'Email ID'
        case 'industry':
          return "Industry"
        case 'industrySegment':
          return 'Industry Segment'
        case 'netProfitInr':
          return 'Net Profit INR'
        case 'netWorthInr':
          return 'Net Worth INR'
        case 'numberOfOpenCharges':
          return 'Number of Open Charges'
        case 'paidUpEquityShareCapitalInr':
          return 'Paid Up Equity Share Capital INR'
        case 'paidUpPreferenceShareCapitalInr':
          return 'Paid Up Preference Share Capital INR'
        case 'pan':
          return 'PAN'
        case 'registeredAddress':
          return 'Registered Address'
        case 'registrationNumber':
          return 'Registraion Number'
        case 'rocCode':
          return 'ROC Code'
        case 'telephoneNumber':
          return 'Telephone Number'
        case 'totalAmountOfOpenChargesInr':
          return 'Total Amount of Open Charges INR'
        case 'turnoverInr':
          return 'Turnover INR'
        case 'website':
          return 'Website'
        case 'whetherSharesListedOnBseOrNse':
          return 'Whether Shares Listed on BSE or NSE'
        case 'authorizedCapital':
          return 'Authorized Capital'
        case 'paidUpCapital':
          return 'Paid Up Capital'
        case 'activeCompliance':
          return 'Active Compliance'
        case 'presentFilingStatus':
          return 'Present Filing Status'
        case 'statusUnderCirp':
          return 'Status Under CIRP'
        default:
          return name
      }
    })()}
  </span>

export default MCAReportPageUI
